import { render, staticRenderFns } from "./detail-list.vue?vue&type=template&id=3e6b8423&scoped=true&"
import script from "./detail-list.vue?vue&type=script&lang=js&"
export * from "./detail-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-list.vue?vue&type=style&index=0&id=3e6b8423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b8423",
  null
  
)

export default component.exports